// What a notification template may actually say — AL7, BUG-1-017.
//
// The render context analytics-service builds
// (`apps/analytics-service/src/alert/event-render.ts`, typed as `RenderContext` in
// `templating.ts`) is
//
//   { rule: {name, displayName, severity, params},
//     labels: {...instance labels, severity},
//     annotations: {...event annotations, evaluated_at},
//     event: {id, firedAt, status, value} }
//
// `event.value` is the measured number the rule fired on, in the unit its threshold
// is written in: for a stock rule the stock itself (not the shortfall Grafana
// reduces), for a missing report the hours of silence. `rule.params.*` are the
// parameters of the rule's condition as saved, so a template can say both the
// measurement and the threshold it crossed: "{{event.value}} < {{rule.params.minQuantity}}".
// Both are absent when the firing carries none, and `{{#if …}}` guards them.
//
// The old hint advertised `{{event.labels.medicineCode}}`, which never existed:
// `event.labels` would be a second spelling of `labels`, so it stays unadvertised.
//
// The label and annotation names below are the ones the safelisted queries emit;
// which of them a given firing carries depends on the rule's kind, which is what
// the hint sentence says and what `{{#if …}}` exists for.
export interface PlaceholderGroup {
  labelKey: string;
  paths: string[];
}

export const TEMPLATE_PLACEHOLDERS: PlaceholderGroup[] = [
  {
    labelKey: 'alerts.templates.placeholders.rule',
    paths: [
      'rule.displayName',
      'rule.name',
      'rule.severity',
      'rule.params.minQuantity',
      'rule.params.medicineCode',
      'rule.params.daysBefore',
      'rule.params.withinHours',
      'rule.params.windowHours',
      'rule.params.windowDays',
    ],
  },
  {
    labelKey: 'alerts.templates.placeholders.event',
    paths: ['event.value', 'event.firedAt', 'event.status', 'event.id', 'annotations.evaluated_at'],
  },
  {
    labelKey: 'alerts.templates.placeholders.labels',
    paths: [
      'labels.severity',
      'labels.rule_kind',
      'labels.medicine_code',
      'labels.lot',
      'labels.site_id',
      'labels.stock_date',
    ],
  },
  {
    labelKey: 'alerts.templates.placeholders.annotations',
    paths: [
      'annotations.medicine_name',
      'annotations.site_name',
      'annotations.site_code',
      'annotations.registrar_name',
      'annotations.registrar_idno',
      'annotations.min_quantity',
      'annotations.total_quantity',
      'annotations.quantity',
      'annotations.days_before',
      'annotations.within_hours',
      'annotations.hours_since_last_report',
      'annotations.window_hours',
      'annotations.duplicates',
      'annotations.window_days',
      'annotations.expired_lots',
    ],
  },
];
